import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import { useApi } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function PaymentSuccess() {
  const api = useApi();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) return setState("error");
    let n = 0, stop = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (stop) return;
        if (data.payment_status === "paid") {
          setState("paid");
          const sent = `pp_ga_${sid}`;
          if (window.gtag && !localStorage.getItem(sent)) {
            localStorage.setItem(sent, "1");
            window.gtag("event", "purchase", {
              transaction_id: sid, value: data.value, tax: data.tax, currency: data.currency,
              items: [{ item_id: data.lookup_key, item_name: data.item_name, price: data.value, quantity: 1 }],
            });
          }
          const back = localStorage.getItem("pp_return") || "/app";
          localStorage.removeItem("pp_return");
          setTimeout(() => navigate(back === "/app" ? back : `${back}?download=1`), 1600);
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("error");
      } catch {}
      if (++n < 15) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [sid, api, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-10 bg-paper px-4">
      <Logo to="/app" />
      <div className="w-full max-w-md rounded-2xl border border-paper-border bg-white p-10 text-center shadow-sm" data-testid="payment-status-card">
        {state === "checking" && <><Loader2 className="mx-auto h-10 w-10 animate-spin text-thread" /><h1 className="mt-5 text-3xl">Confirming payment…</h1><p className="mt-2 text-ink-soft">This only takes a moment.</p></>}
        {state === "paid" && <><CheckCircle2 className="mx-auto h-12 w-12 text-green-600" /><h1 className="mt-5 text-3xl" data-testid="payment-success-title">Payment confirmed</h1><p className="mt-2 text-ink-soft">Taking you back. Your clean PDF will download automatically.</p></>}
        {(state === "error" || state === "timeout") && <><AlertCircle className="mx-auto h-12 w-12 text-thread" /><h1 className="mt-5 text-3xl">{state === "timeout" ? "Still processing" : "Payment not completed"}</h1>
          <p className="mt-2 text-ink-soft">{state === "timeout" ? "Your payment is taking longer than usual. Check your documents in a minute." : "No charge was made. You can try again from the editor."}</p>
          <Link to="/app" className="btn-thread mt-6" data-testid="payment-back-btn">Back to my documents</Link></>}
      </div>
    </div>
  );
}
